<template>
  <v-dialog title="Newsletter Tools" :visible.sync="dialogVisible" :scrollbar="false"
    :width="upload ? '600px' : '1000px'" @closed="onClosed">
    <div class="wrapper" v-if="dialogVisible">
      <el-tabs type="card" v-model="tab">
        <el-tab-pane label="生成链接" name="generateLinks">
          <div v-if="hasLinksResult">
            <el-button class="export" type="primary" icon="iconfont icon-export" @click="exportButton">
              Export
            </el-button>
            <el-table :data="linksList" height="400" v-loading="linksResultLoading" element-loading-text="Loading..."
              header-row-class-name="table-header" row-class-name="table-row">
              <el-table-column prop="index" label="Num" :width="70" />
              <el-table-column prop="link" label="Newsletter Link" />

            </el-table>
          </div>
          <div class="step link" v-else>
            <el-form ref="editForm" :model="form" :rules="formRules" label-width="200px">
              <el-form-item prop="linksNumber" label="请输入链接数量" style="margin-top: 20px;">
                <!-- <div class="line">
                  <span class="title">1.请输入需要生成的链接数量 ：</span>
                  <el-input-number v-model="form.linksNumber" controls-position="right" step-strictly :step="10" :min="10"
                    :max="500" class="step-with">
                  </el-input-number>
                </div> -->
                <el-input-number v-model="form.linksNumber" controls-position="right" step-strictly :step="1" :min="1"
                  :max="500" class="step-with" style="width: 60%;">
                </el-input-number>
              </el-form-item>
              <el-form-item prop="meetingTitle" label="请输入大会名称">
                <!-- <div class="line" style="padding-top:0px">
                  <span class="title" >2.请输入大会名称 ：</span>
                  <el-input v-model="form.meetingTitle" placeholder="Please enter the meeting name" maxlength="30" class="link">
                  </el-input>
                </div> -->
                <el-input v-model="form.meetingTitle" placeholder="Please enter the meeting name" maxlength="30"
                  class="link" style="width: 60%;">
                </el-input>
              </el-form-item>
              <el-form-item prop="dateRange" label="请选择大会日期">
                <!-- <div class="choose-date line">
                  <span class="title">3.选择大会日期 ：</span>
                  <el-date-picker class="date-picker" value-format="yyyy-MM-dd" v-model="form.dateRange" type="daterange"
                    start-placeholder="Begin date" end-placeholder="End date" @change="onDateRangeChange" :clearable="false"
                    style="width: 40%;">
                  </el-date-picker>
                </div> -->
                <el-date-picker class="date-picker" value-format="yyyy-MM-dd" v-model="form.dateRange" type="daterange"
                  start-placeholder="Begin date" end-placeholder="End date" @change="onDateRangeChange"
                  :clearable="false" style="width: 60%;">
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="meetingLocation" label="请输入大会地点">
                <!-- <div class="line" style="padding-top:0px">
                  <span class="title" >2.请输入大会名称 ：</span>
                  <el-input v-model="form.meetingTitle" placeholder="Please enter the meeting name" maxlength="30" class="link">
                  </el-input>
                </div> -->
                <el-input v-model="form.meetingLocation" placeholder="Please enter the meeting location" maxlength="30"
                  class="link" style="width: 60%;">
                </el-input>
              </el-form-item>
              <el-form-item prop="isDownload" label="文件是否可下载">
                <el-radio v-model="form.isDownload" :label="1">Yes</el-radio>
                <el-radio v-model="form.isDownload" :label="0">No</el-radio>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="链接匹配文件" name="linkMappingFile">
          <div v-if="errordata.length > 0">
            <el-button class="export position" type="primary" icon="iconfont icon-export" @click="errorExportButton">
              Export
            </el-button>
            <el-table :data="errordata" height="400" element-loading-text="Loading..."
              header-row-class-name="table-header" row-class-name="table-row">
              <!-- <el-table-column prop="index" label="Num" :width="70" /> -->
              <el-table-column prop="link" label="Link" />
              <el-table-column prop="fileName" label="File Name" />
              <el-table-column prop="checkMessage" label="Error Message" />
            </el-table>
          </div>
          <div v-else>
            <div class="line-wrapper">
              <p class="title">1.请先上传链接与文件名称对照表：
                <el-link class="el-icon-download" @click="downloadTemplate">下载模板</el-link>
              </p>
              <el-upload action="" :http-request="excelUpload" :on-remove="handleRemove" :on-error="onError" multiple
                accept=".xlsx" :disabled="Boolean(batchId)">
                <el-button size="mini" icon="el-icon-plus" type="primary" style="margin-top: 10px;"
                  :disabled="Boolean(batchId)">
                  上传Excel
                </el-button>
              </el-upload>
            </div>

            <div class="line-wrapper">
              <p class="title">2.批量上传文件与链接匹配：</p>
              <el-upload action="" :http-request="customUpload" :on-remove="handleRemove" :on-error="onError"
                :before-upload="beforeUpload" multiple accept=".html,.pdf,.mp4,.pptx" :disabled="!Boolean(batchId)">
                <el-button size="mini" icon="el-icon-plus" type="primary" style="margin-top: 10px;"
                  :disabled="!Boolean(batchId)">
                  批量上传文件
                </el-button>
                <div slot="tip" class="el-upload__tip">
                  <span>Only html/pdf/mp4/pptx files can be uploaded</span>
                  <span class="red"> Total: {{ uploadList.length }} </span>
                </div>
              </el-upload>
            </div>
          </div>

          <!-- <div class="line" style="padding-top:0px">
                  <span class="title" >2.请输入大会名称 ：</span>
                  <el-input v-model="form.meetingTitle" placeholder="Please enter the meeting name" maxlength="30" class="link">
                  </el-input>
                </div> -->
        </el-tab-pane>
      </el-tabs>
    </div>

    <div slot="footer" class="dialog-footer" v-if="showBtn()">
      <el-button type="primary" @click="onSave" :loading="linksResultLoading"> Submit</el-button>
      <el-button @click="onClosed"> Cancel </el-button>
    </div>
  </v-dialog>
</template>
<script>
import { trimValidate } from "../../utils/validator"
import downloadjs from 'downloadjs'
import { export_json_to_excel_new } from "@/utils/Export2Excel";

export default {
  name: 'UploadDialog',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    maximumSize: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      batchId: null,
      errordata: [],
      dialogVisible: this.visible,
      dateRange: [],
      upload: true,
      exporting: false,
      uploadList: [],
      tableData: [],
      tab: "generateLinks",
      linksNumber: '',
      meetingTitle: '',
      meetingLocation: '',
      hasLinksResult: false,
      linksList: [],
      excelHeader:[
        { header: 'Num', key: "index" },
        { header: 'Newsletter Link', key: "link" },
      ],
      errorExcelHeader:[
        { header: 'Link', key: "link" },
        { header: 'File Name', key: "fileName" },
        { header: 'Error Message', key: "checkMessage" },
      ],
      linksResultLoading: false,
      form: {
        linksNumber: '',
        meetingTitle: '',
        dateRange: '',
        meetingLocation: '',
        isDownload: 0,
      },
      formRules: {
        linksNumber: [
          {
            required: true,
            tigger: "blur",
            validator: trimValidate("请输入链接数量"),
          },
        ],
        meetingTitle: [
          {
            required: true,
            tigger: "blur",
            validator: trimValidate("请输入大会名称"),
          },
        ],
        dateRange: [
          {
            required: true,
            tigger: "blur",
            validator: trimValidate("请选择大会日期"),
          },
        ],
        meetingLocation: [
          {
            required: true,
            tigger: "blur",
            validator: trimValidate("请输入大会举办地点"),
          },
        ],
        isDownload: [
          { required: true, message: '请选择是否可下载', trigger: 'change' }
        ],
      }
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
    },
  },
  mounted() { },
  computed: {
    fromDate() {
      return this.form.dateRange.length > 0 ? this.form.dateRange[0] : "";
    },
    toDate() {
      return this.form.dateRange.length > 0 ? this.form.dateRange[1] : "";
    },
    templateUrl() {
      return "/template/NewsletterImportTemplate.xlsx";
    },
  },
  methods: {
    onError(err, file) {
      this.$notify({
        title: 'Error',
        message: `The ${file.name} File uploading fails`,
        type: 'error',
        duration: 0,
      })
    },

    excelUpload(fileObject) {
      let formData = new FormData()
      formData.append('file', fileObject.file)
      this.axios
        .post('/sys/importMapping', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            let percent =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0
            fileObject.onProgress({ percent: percent })
          },
        })
        .then((res) => {
          if (res.data.successStatus === true) {
            this.batchId = res.data.batchId
            fileObject.onSuccess()
          } else {
            if (res.data.errordata.length > 0) {
              this.errordata = res.data.errordata
            } else {
              this.$message({
                type: 'error',
                message: res.data.errorMessage,
              })
            }

            // fileObject.onError()
          }
        })
        .catch(() => {
          fileObject.onError()
        })
    },
    formatJson(headers, rows) {
      return rows.map((item) => {
        return Object.keys(headers).map((key) => {
          return item[headers[key]];
        });
      });
    },
    onDateRangeChange() {
      console.log(this.fromDate);
      console.log(this.toDate);
    },
    async exportButton() {
      const header = this.excelHeader
      const data = this.linksList
      const filename = "Generate Links"
      await export_json_to_excel_new(header,data,filename)
    },
    async errorExportButton() {
      const header = this.errorExcelHeader
      const data = this.errordata
      const filename = "Mapping Error Message Export"
      await export_json_to_excel_new(header,data,filename)
    },
    beforeUpload(file) {
      const isVideo = file.type === 'video/mp4'
      if (isVideo) {
        const isLt2M = file.size / 1024 / 1024 < this.maximumSize
        if (!isLt2M) {
          setTimeout(() => {
            this.$notify({
              title: 'Error',
              message: `The ${file.name} video size must not exceed ${this.maximumSize}MB!`,
              type: 'error',
              duration: 0,
            })
          })
        }
        return isLt2M
      }
      return true
    },
    download() {
      this.exporting = true
      this.axios
        .get(`sys/exportNewsLetter`, {
          params: {
            GroupID: this.GroupID,
          },
          responseType: 'blob',
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, 'application/vnd.ms-excel')
          this.exporting = false
        })
        .catch(() => {
          this.exporting = false
        })
    },
    downloadTemplate() {
      this.axios
        .get(this.templateUrl, {
          baseURL: "/",
          responseType: "blob",
        })
        .then((data) => {
          downloadjs(
            data,
            `Newsletter_Link_Mapping_Template.xlsx`,
            "application/vnd.ms-excel"
          );
          this.$message.success(`Download import template successful!`);
        });
    },
    customUpload(fileObject) {
      let formData = new FormData()
      formData.append('file', fileObject.file)
      this.axios
        .post('/sys/uploadNewsLetter', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            let percent =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0
            fileObject.onProgress({ percent: percent })
          },
        })
        .then((res) => {
          if (res.code === 200) {
            this.uploadList.push(res.data)
            fileObject.onSuccess()
          } else {
            fileObject.onError()
          }
        })
        .catch(() => {
          fileObject.onError()
        })
    },

    handleRemove(file) {
      this.uploadList = this.uploadList.filter(
        (item) => item.OriginalName !== file.name
      )
    },
    onClosed() {
      Object.assign(this.$data, this.$options.data())
      this.$emit('update:visible', false)
    },
    onSave() {
      if (this.tab == 'generateLinks') {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.getLinksTable()
          } else {
            return false;
          }
        });
      }
      else {
        this.getMappingFilesTable()
      }


    },
    showBtn() {
      let showBtn = true
      switch (this.tab) {
        case 'generateLinks':
          //有link结果就不用再次生成
          if (this.hasLinksResult) {
            return false
          }
          break;
        case 'linkMappingFile':
          //有错误数据就不让提交
          if (this.errordata.length > 0) {
            return false
          }
          break;
        default:
          break;
      }
      return showBtn
    },
    getLinksTable() {
      this.linksResultLoading = true
      this.axios
        .post('/sys/generateLink', {
          count: this.form.linksNumber,
          title: this.form.meetingTitle,
          location: this.form.meetingLocation,
          fromDate: this.fromDate,
          toDate: this.toDate,
          isDownload: this.form.isDownload
        })
        .then((res) => {

          this.linksResultLoading = false
          if (res.code == 200) {
            this.hasLinksResult = true
            this.linksList = res.data.map((item, index) => {
              return {
                index: index + 1,
                link: item
              }
            })
          } else {
            this.$message({
              type: 'error',
              message: res.msg,
            })
          }
        })
    },
    getMappingFilesTable() {
      if (!this.batchId) {
        this.$message.error('请先上传excel文件')
        return
      }
      if (this.uploadList.length == 0) {
        this.$message.error('请先上传匹配文件')
        return
      }
      this.linksResultLoading = true
      this.axios
        .post('/sys/saveNewsletterMapping', {
          batchId: this.batchId,
          filePaths: this.uploadList,
        })
        .then((res) => {
          this.linksResultLoading = false
          if (res.code == 200) {
            if (res.data.successStatus === true) {
              this.$message.success('提交成功')
              this.onClosed()
            } else {
              this.errordata = res.data.errordata
            }
            //this.onClosed()
          } else {
            this.onClosed()
            this.$message({
              type: 'error',
              message: res.msg,
            })
          }
        })

    }
  },
}
</script>
<style lang="scss" scoped>
.main {
  padding: 20px;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
}

::v-deep {
  .el-dialog__body {
    padding: 0 !important;
    display: flex;
    justify-content: center;
  }
}

.el-upload__tip {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.red {
  color: #d52b1e;
}

.dialog-footer {
  text-align: center;
}

.wrapper {
  width: 90%;
  margin: 10px auto;
  min-height: 30vh;

}

.step {
  &.link {
    margin: auto 0;
    width: 100%;
  }
}

.export {
  position: absolute;
  z-index: 1;
  right: 0;
}

.step-with {
  width: 50%;
}

.link {
  width: 50%;

}

.choose-date {
  padding-top: 10px;
}

.line {
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  width: 42%
}

.dis {
  width: 50%;
}

.line-wrapper {
  width: 70%;
  margin: 20px auto;

  .title {
    width: 100%;
  }
}

.position {
  position: relative;
}
</style>
